import { useEffect, useState } from "react";
import { observer } from "mobx-react";
import { __, _x } from "../../utils";
import { Spin, Modal } from "antd";
const PluginUpdateLicenseTelemetryDataModal = observer(_ref => {
  let {
    license,
    linkWrapper,
    disabled,
    children
  } = _ref;
  const {
    busy,
    telemetryData,
    telemetryDataSharingOptIn
  } = license;
  const [isVisible, setVisible] = useState(false);
  useEffect(() => {
    if (isVisible && !telemetryData) {
      license.fetchTelemetryData();
    }
  }, [isVisible, telemetryData, license]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal, {
    title: __("Telemetry data preview"),
    open: isVisible && !disabled,
    onCancel: () => setVisible(false),
    cancelText: __("Close"),
    okButtonProps: {
      style: {
        display: "none"
      }
    }
  }, telemetryDataSharingOptIn && /*#__PURE__*/React.createElement("p", {
    style: {
      marginTop: 0,
      marginBottom: 10
    }
  }, _x("At the time of activating the license, you agreed that we may send telemetry data from your installation to our server. You can revoke this at any time by deactivating and reactivating the licence.", "legal-text")), /*#__PURE__*/React.createElement("p", {
    style: {
      marginTop: 0
    }
  }, __("The following data (raw) will be sent to our server:")), /*#__PURE__*/React.createElement(Spin, {
    spinning: busy
  }, /*#__PURE__*/React.createElement("textarea", {
    readOnly: true,
    style: {
      width: "100%",
      height: 300
    },
    value: telemetryData ? JSON.stringify(telemetryData, null, 4) : ""
  }))), /*#__PURE__*/React.createElement("span", {
    onClick: e => {
      if (!disabled) {
        setVisible(true);
      }
      e.preventDefault();
    }
  }, linkWrapper ? /*#__PURE__*/React.createElement("a", null, children) : children));
});
export { PluginUpdateLicenseTelemetryDataModal };